export const asset = (path) => `${process.env.PUBLIC_URL}/assets/${path}`;
